import React, { useState, useEffect } from "react";
import { message, Button, Modal } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import OrdersTable from "./OrdersTable";
import MarketPlaceService from "../../../utils/api/marketplace";
import LayoutPage from "../../../layouts/Main";

export default function PurchaseOrders(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user: urlUser } = useParams();
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const role = localStorage.getItem("role");

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [isLoginGateModalOpen, setIsLoginGateModalOpen] = useState(false);
  const [isAccessBlocked, setIsAccessBlocked] = useState(false);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const rawLoginFlag = (query.get('login') || query.get('requireLogin') || '').toLowerCase();
    const shouldRequestLogin = rawLoginFlag === '1' || rawLoginFlag === 'true' || rawLoginFlag === 'yes';
    const enforceLoginOnRoute = true;
    const shouldValidateSession = enforceLoginOnRoute || shouldRequestLogin;

    if (!shouldValidateSession) return;

    let parsedUser = null;
    try {
      parsedUser = JSON.parse(localStorage.getItem('user') || 'null');
    } catch (error) {
      parsedUser = null;
    }

    const hasUserSession = Boolean(parsedUser?.id && localStorage.getItem('role'));
    const hasToken = Boolean(localStorage.getItem('token'));
    const hasSession = hasUserSession || hasToken;

    if (hasSession) {
      setIsAccessBlocked(false);
      setIsLoginGateModalOpen(false);
      return;
    }

    const explicitRedirect = query.get('redirect') || query.get('redirectTo');
    const cleanedQuery = new URLSearchParams(location.search);
    ['login', 'requireLogin', 'redirect', 'redirectTo'].forEach((param) => cleanedQuery.delete(param));
    const cleanSearch = cleanedQuery.toString();
    const currentPagePath = `${location.pathname}${cleanSearch ? `?${cleanSearch}` : ''}${location.hash || ''}`;

    localStorage.setItem('post_login_redirect', explicitRedirect || currentPagePath);
    setIsAccessBlocked(true);
    setIsLoginGateModalOpen(true);
    setLoading(false);
  }, [location.hash, location.pathname, location.search]);

  const loadOrders = async () => {
    if (isAccessBlocked) return;

    try {
      setLoading(true);
      setError(null);
      
      let response;
      
      if (role === '6') { 
        const supplierId = urlUser || user.id;
        response = await MarketPlaceService.getOrderBySupplier(supplierId);
      } 
      else if (role === '1') { // Admin
        response = await MarketPlaceService.getAllOrders();
      } 
      else if (role === '4') { // Industry (clients)
        response = await MarketPlaceService.getOrderByClient(user.id);
      } 
      else {
        response = await MarketPlaceService.getAllOrders();
      }
      
      let ordersData = [];
      if (Array.isArray(response)) {
        ordersData = response;
      } else if (response && response.data && Array.isArray(response.data)) {
        ordersData = response.data;
      } else if (response && response.data && Array.isArray(response.data.orders)) {
        ordersData = response.data.orders;
      } else if (response && Array.isArray(response.orders)) {
        ordersData = response.orders;
      }
      
      setOrders(ordersData);
      
    } catch (error) {
      const errorMsg = 'Error en la base de datos, intentelo más tarde.';
      setError(errorMsg);
      messageApi.error(errorMsg);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      await MarketPlaceService.updateOrderStatus(orderId, { status: newStatus });
      messageApi.success('Estado actualizado correctamente');
      await loadOrders();
      return true;
    } catch (error) {
      messageApi.error('Error al actualizar el estado');
      return false;
    }
  };

  useEffect(() => {
    if (isAccessBlocked) return;
    loadOrders();
  }, [role, user?.id, urlUser, isAccessBlocked]);

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  const handleRegisterRedirect = () => {
    navigate('/register');
  };

  return (
    <LayoutPage>
      {contextHolder}
      <Modal
        open={isLoginGateModalOpen}
        onCancel={() => {}}
        footer={null}
        centered
        closable={false}
        maskClosable={false}
        keyboard={false}
        width={420}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ background: '#0F5197', color: '#fff', padding: '28px 24px', textAlign: 'center' }}>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>
            Inicia sesión para continuar
          </h2>
          <p style={{ margin: '8px 0 0', fontSize: 14, opacity: 0.95 }}>
            Para ver tus órdenes, primero debes autenticarte.
          </p>
        </div>
        <div style={{ padding: '18px 24px 24px' }}>
          <Button
            type="primary"
            block
            size="large"
            onClick={handleLoginRedirect}
            style={{ background: '#0F5197', borderColor: '#0F5197', fontWeight: 600 }}
          >
            Iniciar sesión
          </Button>
          <Button
            block
            size="large"
            onClick={handleRegisterRedirect}
            style={{ marginTop: 12, fontWeight: 600 }}
          >
            Crear cuenta
          </Button>
        </div>
      </Modal>
      
      {!isAccessBlocked && (
        <OrdersTable 
          orders={orders} 
          loading={loading}
          role={role}
          onStatusChange={handleStatusChange}
        />
      )}
    </LayoutPage>
  );
}